import { actions } from 'actions/modal';

const initialState = null;

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case actions.MODAL_OPEN:
      return payload;
    case actions.MODAL_CLOSE:
      return null;
    default:
      return state;
  }
}
